// extracted by mini-css-extract-plugin
export default {"download-link":"GQSvywHPwg3Fzaq9klpR"};